import { render, staticRenderFns } from "./asset-line.vue?vue&type=template&id=2f52c34b"
import script from "./asset-line.vue?vue&type=script&lang=js"
export * from "./asset-line.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports